import { Badge, Icon } from "@elaniintc/goes-design-system";
import { FORM_ASSIGNMENTS_STATUS } from "@/types/entities/formality-request";
import { cn } from "@/utils/theme";

/**
 * Get the badge component based on the procedure status
 *
 * @param status ProcedureSubmissionStatus
 * @returns
 */
export const getBadge = (
  status: keyof typeof FORM_ASSIGNMENTS_STATUS,
  isCancelled: boolean | undefined,
) => {
  switch (status) {
    case FORM_ASSIGNMENTS_STATUS.SUBMITTED:
      return (
        <Badge size="xs" variant="info">
          Enviado
          <Icon type="fas" name="envelope" className="text-info-quiet" />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.COMPLETED:
      return (
        <Badge size="xs" variant="success">
          Completado
          <Icon type="far" name="check" className="text-success-quiet" />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.IN_PROGRESS:
      return (
        <Badge size="xs" variant={isCancelled ? "disabled" : "action"}>
          En progreso
          <Icon
            type="fas"
            name="arrows-rotate"
            className={cn({
              "text-action-quiet": !isCancelled,
              "text-on-disabled": isCancelled,
            })}
          />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.CORRECTION:
      return (
        <Badge size="xs" variant="info">
          Revisión
          <Icon type="fas" name="file-edit" className="text-info-quiet" />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.FILL_CORRECTION:
      return (
        <Badge size="xs" variant="warning">
          Observado
          <Icon type="fas" name="file-edit" className="text-warning-quiet" />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.ASSIGNED:
      return (
        <Badge
          size="xs"
          variant="neutral"
          className="text-on-disabled hover:text-on-disabled"
        >
          Pendiente
          <Icon type="fas" name="square" />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.PENDING:
      return (
        <Badge size="xs" variant="info">
          Pendiente
          <Icon type="fas" name="clock" className="text-info-quiet" />
        </Badge>
      );
    case FORM_ASSIGNMENTS_STATUS.FAILED_CORRECTION:
      return (
        <Badge size="xs" variant="danger">
          Rechazado
          <Icon type="fas" name="times" className="text-error-quiet" />
        </Badge>
      );
    default:
      return null;
  }
};
